(function() {
    var preloaderElement = document.getElementById("page-transition-preloader");
    var managePreloaderVisibility = function(visible) {
      preloaderElement.style.display = visible ? "flex" : "none"
    };
  
    window.addEventListener("load", function() {
        managePreloaderVisibility(false);
        document.addEventListener("click", function(event) {
            var target = event.target;
            if (!event.defaultPrevented)
                for (; target !== document; ) {
                    if (target.matches('a:not([target="_blank"])')) {
                        event = target.getAttribute("href");
                        "javascript" !== event.substr(0, 10) && "#" !== event.substr(0, 1) && managePreloaderVisibility(true);
                        break;
                    }
                    target = target.parentNode;
                }
        })
    });
    document.addEventListener("submit", function(event) {
        event.defaultPrevented || managePreloaderVisibility(true);
    });
    window.addEventListener("pageshow", function(event) {
        event.persisted && managePreloaderVisibility(false);
    });
    window.addEventListener("beforeunload", function() {
        managePreloaderVisibility(true);
    })
}
)();
